export default "__VITE_ASSET__CkJmd_mP__"